import { createSelector } from '@reduxjs/toolkit';

import { getRuleModel } from 'src/containers/ProjectDiagram/utils/rules/getRuleModel';
import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';

export const projectRuleModelSelector = (projectId: string) =>
  createSelector(diagramSnapshotSelector(projectId), (diagram) =>
    diagram
      ? getRuleModel(diagram.model)
      : { classesByIri: {}, propertiesByIri: {} }
  );
